module.exports = ["script","style","pre","textarea"]


//////////////////
// WEBPACK FOOTER
// ../node_modules/html-whitespace-sensitive-tag-names/index.json
// module id = 1010
// module chunks = 0